import { Environment } from '../../../environment';
import { Api } from '../axioscadastro';
import { v4 as uuidv4 } from 'uuid';
export interface IListagemUsuarios {
    iduser: number;
    nome: string;
    login: string;
    status: boolean;
    urlimg: string;
}
export interface IDetalhesUsuarios {
  nome: string;
  login: string;
  senha: string;
  urlimg:string;
  status: boolean;
}
export interface ICreateUsuarios {
  nome: string;
  login: string;
  senha: string;
  status?: boolean;
}
export interface IUpdateUsuarios {
  status: boolean;
}
export interface IGetUsuarios {
  nome: string;
  login:string;
  urlimg:string;
  status: boolean;
 
}
interface IUpdateSenha {
  nome: string;
  login: string;
  senha: string;
  novasenha: string;
  confirmarsenha: string;
}
export interface ISenha {
  senha: string;
} 
export interface IPermissao {
  idpermissoes: string;
  iduser: string;
	metodo: string;
	url: string;
	descricao: string;
	permissoes: boolean;
} 
type TComTotalCount = {
    data: IListagemUsuarios[];
    totalCount: number;
}

type TComTotalCountPermissao = {
  data: IPermissao[];
  totalCount: number;
}

const getAll = async (page = 1, filter = ''): Promise<TComTotalCount | Error> => {
  try {
    const urlRelativa = `/users?page=${page}&limit=${Environment.LIMITE_DE_LINHAS}&filter=${filter}`;
    const { data, headers } = await Api.get(urlRelativa);

    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};
const getByIdPerfil = async (id: string): Promise<IGetUsuarios | Error> => {
  try {
    const { data } = await Api.get(`/users/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};
const getAllPermissao = async (id: string, page = 1, modulo: string, filter = ''): Promise<TComTotalCountPermissao | Error> => {
  try {
    const { data, headers } = await Api.get(`/permissao/${id}?page=${page}&modulo=${modulo}&filter=${filter}&limit=${10}`);

    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || 9),
      };
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};

const create = async (dados: ICreateUsuarios): Promise<void | Error> => {
  try {
    const guuid = uuidv4();

    const { data } = await Api.post<ICreateUsuarios>('/users',  {iduser: guuid, ...dados});
    if (Object.keys(data).length === 0) {
      return ;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
  }
};
const updateByIdPermissao = async (idpermissoes: string, pemissoes: boolean): Promise<void | Error> => {
  try {
    const dados = {idpermissoes: idpermissoes, permissoes: pemissoes};
    await Api.put(`/permissao/${idpermissoes}`,  dados);
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};
const updateByIdImg = async (iduser: string, imge: File | undefined, dados: ISenha): Promise<void | Error> => {
  try {
    const { data } = await Api.post<ICreateUsuarios>('/usersavatar', {iduser: iduser, ...dados});
    if (data) {
      const formData = new FormData();
      formData.append('file', imge || ''); 
      await Api.put(`/usersavatar/${iduser}`, formData);
      return;
    }
    return new Error('Erro ao Atualizar Foto.');

  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao Atualizar Foto.');
  }
};
const getById = async (id: string): Promise<IGetUsuarios | Error> => {
  try {
    const { data } = await Api.get(`/users/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};
const updateById = async (id: string, dados: IUpdateUsuarios): Promise<void | Error> => {
  try {
    await Api.put(`/users/${id}`, dados);
  } catch (errors) {
    return new Error((errors as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};
const updatesenha = async (id: string, dados: IUpdateSenha): Promise<void | Error> => {
  try {
    await Api.put(`/userssenha/${id}`, dados);
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};
export const UsuarioService = {
  getAll,
  create,
  getAllPermissao,
  updateByIdPermissao,
  updateByIdImg,
  getById,
  updateById,
  updatesenha,
  getByIdPerfil,
};